/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useContext } from 'react';
import './skills.scss';
import EditIcon from '../../Assets/images/svg/dar_pencil.svg';
import DisabledEditIcon from '../../Assets/images/svg/dar_pencil_gray.svg';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';
import ControlledSwitches from '../../Components/Switch/switch';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import { getSkills } from '../../Api/request/skills';
import UseAxios from '../../Api/http/http';
import EnableDisableSkillDialog from './enableDisableSkillDialog';
import {
  handleDialogSubmit,
  handleDialogClose,
} from './enableDisableSkillDialogUtils';
import ButtonComponent from '../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import {
  ADD_EDIT_SKILLS,
  ADD_EDIT_RESPONSE_MESSAGES,
  DOWNLOAD,
  SKILL_MASTER,
  SKILL_MASTER_TABLE_FIELD,
  SKILL_MASTER_TABLE_HEADER,
} from '../../Constants/strings';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDown from '../../Assets/images/svg/drop-down-arrow.svg';
import pdfIcon from '../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../Assets/images/svg/pdf_hover.svg';
import excelIcon from '../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../Assets/images/svg/excel_hover.svg';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';
import { AuthContext } from '../../Contexts/AuthContext';
import SkillForm from './AddEditSkill/addEditSkill';
import { departmentData, verticalData } from '../../Api/request/master';
import {
  getSkillsDataPdf,
  getSkillsDataExcel,
} from '../../Api/request/reports';
import SimpleSnackbar from '../../Components/Snackbar/snackbar';
import { MODULE_NAMES } from '../../Constants/modules';
import PropTypes from 'prop-types';

const Skills = () => {
  const [rows, setRows] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchText, setSearchText] = useState('');
  const { userProfile } = useContext(AuthContext);
  const [skillModalOpen, setSkillModalOpen] = useState(false);
  const [verticals, setVerticals] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [editSkillModalOpen, setEditSkillModalOpen] = useState(false);
  const [editSkillData, setEditSkillData] = useState({
    id: null,
    name: '',
    department: '',
    vertical: '',
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [snackBarCss, setSnackBarCss] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPdfHovered, setIsPdfHovered] = useState(false);
  const [isExcelHovered, setIsExcelHovered] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_TRAINING_SKILL] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const getSkillsData = () => {
    // Fetch skills list using API
    setIsLoading(true);
    UseAxios(getSkills())
      .then((response) => {
        const skills = response.data.skillDetails.map((skill) => ({
          ...skill,
          id: skill.id,
          verticals: skill?.verticals?.join(','), // Convert array to comma-separated string
        }));
        setRows(skills);
        setIsLoading(false);
      })
      .catch(() => {
        setRows([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getSkillsData();
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
    setIsLaptopView(window.innerWidth >= 1024 && window.innerWidth <= 1200);
  };

  const handleCloseMenu = () => {
    // handle close action on download reports
    setAnchorEl(null);
  };
  const handleDownloadClick = (event) => {
    // handle download reports
    setAnchorEl(event.currentTarget);
  };

  const handleSearch = (event) => {
    // Function to handle search in skill table
    setSearchText(event.target.value.toLowerCase());
  };
  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };
  const handleDownloadPdf = async () => {
    try {
      await getSkillsDataPdf();
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const updateSkillList = () => {
    getSkillsData();
    setSearchText('');
    clearSearchInput();
  };
  const clearSearchInput = () => {
    const searchInput = document.getElementById('skill-search-input');
    if (searchInput) {
      searchInput.value = '';
    }
  };

  // Fetch vertical,department using API
  const getOptionsData = () => {
    UseAxios(verticalData())
      .then((response) => {
        const result = response.data.verticalDetails.map((vertical) => ({
          id: vertical.id,
          name: vertical.verticalName,
        }));
        setVerticals(result);
      })
      .catch((error) => {
        console.error('vertical error', error);
      });

    UseAxios(departmentData())
      .then((response) => {
        const result = response.data.departmentDetails.map((dept) => ({
          id: dept.id,
          name: dept.deptName,
        }));
        setDepartments(result);
      })
      .catch((error) => {
        console.error('department error', error);
      });
  };

  const handleAddSkillClick = () => {
    getOptionsData();
    setSkillModalOpen(true);
  };

  const handleAddSkillClose = () => {
    setSkillModalOpen(false);
  };

  const editSkillHandleClickOpen = (
    skillId,
    skillName,
    skillDepartment,
    skillVertical,
  ) => {
    getOptionsData();
    setIsEdit(true);
    setEditSkillModalOpen(true);
    setEditSkillData({
      id: skillId,
      name: skillName,
      department: skillDepartment,
      vertical: skillVertical,
    });
  };

  const handleDownloadExcel = async () => {
    try {
      await getSkillsDataExcel();
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };
  const filteredRows
    = searchText.length >= 1
      ? rows.filter((row) => {
        return (
          row.skillName.toLowerCase().includes(searchText)
            || row.skillCode.toLowerCase().includes(searchText)
            || row.department.toLowerCase().includes(searchText)
            || row.verticals.toLowerCase().includes(searchText)
        );
      })
      : rows;

  const handleSwitchChange = (data) => {
    // Actions to be performed after toggling enable/disable switch
    data.last_updated_by = userProfile.user_name;
    setSelectedSkill(data); // Set the selected skill data
    setIsDialogOpen(true);
    setIsEdit(true);
  };

  const enableDisableSkillSnackbar = (
    message,
    severityDetails,
    cssClassName,
  ) => {
    setSnackBarCss(cssClassName);
    setOpenSnackbar(true);
    setSnackbarMessage(message);
    setSeverity(severityDetails);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };

  const getColumnWidth = (mobileView, laptopView, mobileWidth, laptopWidth, desktopWidth) => {
    if (mobileView) {
      return mobileWidth;
    }
    if (laptopView) {
      return laptopWidth;
    }
    return desktopWidth;
  };

  const getColumnFlex = (mobileView, laptopView, mobileFlex, laptopFlex, desktopFlex) => {
    if (mobileView) {
      return mobileFlex;
    }
    if (laptopView) {
      return laptopFlex;
    }
    return desktopFlex;
  };

  const columns = [
    {
      field: SKILL_MASTER_TABLE_FIELD.SKILL_CODE,
      headerName: SKILL_MASTER_TABLE_HEADER.SKILL_ID,
      width: getColumnWidth(isMobileView, isLaptopView, 150, 150, undefined),
      flex: getColumnFlex(isMobileView, isLaptopView, undefined, undefined, 0.14),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: SKILL_MASTER_TABLE_FIELD.SKILL_NAME,
      headerName: SKILL_MASTER_TABLE_HEADER.SKILL_NAME,
      headerClassName: 'skill-name-column',
      cellClassName: 'skill-name-cell',
      width: getColumnWidth(isMobileView, isLaptopView, 185, 170, undefined),
      flex: getColumnFlex(isMobileView, isLaptopView, undefined, undefined, 0.15),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: SKILL_MASTER_TABLE_FIELD.DEPARTMENT,
      headerName: SKILL_MASTER_TABLE_HEADER.DEPARTMENT,
      headerClassName: 'department-column',
      cellClassName: 'department-cell',
      width: getColumnWidth(isMobileView, isLaptopView, 260, 250, undefined),
      flex: getColumnFlex(isMobileView, isLaptopView, undefined, undefined, 0.21),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: SKILL_MASTER_TABLE_FIELD.VERTICAL,
      headerName: SKILL_MASTER_TABLE_HEADER.VERTICAL,
      headerClassName: 'vertical-column',
      cellClassName: 'vertical-cell',
      width: getColumnWidth(isMobileView, isLaptopView, 410, 290, undefined),
      flex: getColumnFlex(isMobileView, isLaptopView, undefined, undefined, 0.21),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const mobileColumns = [];
  const desktopColumns = [];

  if (isLaptopView || isMobileView) {
    mobileColumns.push(...columns);
    mobileColumns.push({
      field: 'action',
      headerName: 'Actions',
      width: 120,
      flex: !isMobileView && !isLaptopView ? 0.3 : undefined,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      renderCell: (params) => (
        <div className="mobile-action-icons">
          <ControlledSwitches
            disabled={!hasAccess('delete')} // Disable switch based on permission
            checked={Boolean(params.row[SKILL_MASTER_TABLE_FIELD.IS_ACTIVE])}
            handleChange={() => {
              handleSwitchChange(params.row);
            }}
            inputProps={{ 'aria-label': 'enable/disable' }}
            switchCss="switchCss"
          />
          <EditButton
            hasAccess={hasAccess}
            onClick={() =>
              editSkillHandleClickOpen(
                params.row.id,
                params.row.skillName,
                params.row.department,
                params.row.verticals,
              )
            }
            disabledIcon={DisabledEditIcon}
            enabledIcon={EditIcon}
          />
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    });
  } else {
    desktopColumns.push(...columns);
    desktopColumns.push(
      {
        field: SKILL_MASTER_TABLE_FIELD.IS_ACTIVE,
        headerName: SKILL_MASTER_TABLE_HEADER.ENABLE_DISABLE,
        flex: 0.12,
        headerClassName: 'enable-disable-column',
        cellClassName: 'enable-disable-cell',
        renderCell: (params) => (
          <ControlledSwitches
            disabled={!hasAccess('delete')} // Disable switch based on permission
            checked={Boolean(params.value)}
            handleChange={() => {
              handleSwitchChange(params.row);
            }}
            inputProps={{ 'aria-label': 'enable/disable' }}
            switchCss="switchCss"
          />
        ),
        sortable: false,
        disableColumnMenu: true,
      },
      {
        field: SKILL_MASTER_TABLE_FIELD.ACTION,
        headerName: SKILL_MASTER_TABLE_HEADER.ACTION,
        headerClassName: 'action-column',
        cellClassName: 'action-cell',
        type: 'number',
        flex: 0.06,
        renderCell: (params) => (
          <EditButton
            hasAccess={hasAccess}
            onClick={() =>
              editSkillHandleClickOpen(
                params.row.id,
                params.row.skillName,
                params.row.department,
                params.row.verticals,
              )
            }
            disabledIcon={DisabledEditIcon}
            enabledIcon={EditIcon}
          />
        ),
        sortable: false,
        disableColumnMenu: true,
      },
    );
  }

  const sortFilterColumns = [
    columns[0].field,
    columns[1].field,
    columns[2].field,
    columns[3].field,
  ];

  return (
    <div className="skill-master-outer-layer">
      <div className="skill-master">
        <div className="skill-master-title">{SKILL_MASTER}</div>
        <div className="skill-search-and-buttons">
          <div className="skill-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="skill-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
          <div className="skill-button">
            <div className="skill-button-download ">
              <ButtonComponent
                label={DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img src={ArrowDropDown} alt="Dropdown Arrow" />}
                btnCss="download-skill-btn"
              ></ButtonComponent>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={handleDownloadPdf}
                  className="downloadskill-dropdown"
                  onMouseEnter={() => setIsPdfHovered(true)}
                  onMouseLeave={() => setIsPdfHovered(false)}
                >
                  <img
                    src={isPdfHovered ? pdfhoverIcon : pdfIcon}
                    style={{ marginRight: 8 }}
                    alt="PDF Icon"
                  />{' '}
                  Download as PDF
                </MenuItem>
                <MenuItem
                  onClick={handleDownloadExcel}
                  className="downloadskill-dropdown"
                  onMouseEnter={() => setIsExcelHovered(true)}
                  onMouseLeave={() => setIsExcelHovered(false)}
                >
                  <img
                    src={isExcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="excel Icon"
                  />{' '}
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>
            <div>
              <ButtonComponent
                disabled={!hasAccess('create')} // Disable add button based on permission
                label={ADD_EDIT_SKILLS.ADD_SKILL}
                variant="contained"
                onClick={() => {
                  handleAddSkillClick();
                  setIsEdit(false);
                }}
                startIcon={<AddIcon />}
                btnCss={
                  !hasAccess('create')
                    ? 'add-skill-btn-disabled'
                    : 'add-skill-btn'
                }
              ></ButtonComponent>
            </div>
            <SkillForm
              modalOpen={skillModalOpen}
              handleClose={handleAddSkillClose}
              verticalOption={verticals}
              departmentOption={departments}
              setRows={updateSkillList}
            />
            <SkillForm
              modalOpen={editSkillModalOpen}
              handleClose={() => {
                setEditSkillModalOpen(false);
                setIsEdit(false);
              }}
              verticalOption={verticals}
              departmentOption={departments}
              setRows={setRows}
              isEditMode={true}
              isEdit={isEdit}
              skillId={editSkillData.id}
              initialSkillName={editSkillData.name}
              initialDepartmentValue={editSkillData.department}
              initialVerticalValue={[editSkillData.vertical]}
            />
          </div>
        </div>
        <div className="data-grid-container">
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
              }}
            >
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : filteredRows ? (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={
                isMobileView || isLaptopView ? mobileColumns : desktopColumns
              }
              isFilteredRows={filteredRows}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isEdit={isEdit}
            />
          ) : null}
        </div>
      </div>
      {isDialogOpen
        && selectedSkill && ( // Enable/Disable skill dialog
        <EnableDisableSkillDialog
          selectedSkill={selectedSkill}
          handleCloseAction={handleDialogClose}
          handleEnableDisableAction={handleDialogSubmit}
          setIsDialogOpen={setIsDialogOpen}
          setRows={setRows}
          handleSnackbar={enableDisableSkillSnackbar}
          setIsEdit={setIsEdit}
        />
      )}
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        alertCss={snackBarCss}
      />
    </div>
  );
};

const EditButton = ({ hasAccess, onClick, disabledIcon, enabledIcon }) => (
  <button
    disabled={!hasAccess('update')} // 1 Disable edit button based on permission
    id="skillMaster-edit-icon"
    className="skill-action-edit-icon"
    onClick={onClick}
    style={{
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
    }}
    aria-label="Edit"
  >
    <img
      src={!hasAccess('update') ? disabledIcon : enabledIcon}
      alt="Edit"
    />
  </button>
);
EditButton.propTypes = {
  hasAccess: PropTypes.func.isRequired, // Ensures hasAccess is a function
  onClick: PropTypes.func.isRequired, // Ensures onClick is a function
  disabledIcon: PropTypes.isRequired, // Ensures disabledIcon is a string (image path or URL)
  enabledIcon: PropTypes.isRequired, // Ensures enabledIcon is a string (image path or URL)
};
export default Skills;
